import { useStore as useReactFlowStore } from 'reactflow'
import { arabNumberToRoman } from '../../../../utils/arabNumberToRoman'

export const ResearchTreeHeader = ({ selectedRank }: { selectedRank: number }) => {
  const ranks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  // transform: [x, y, zoom]
  const x = useReactFlowStore((s) => s.transform[0])
  const offsetX = 100 + x

  return (
    <div className="research-tree-header-wrapper">
      <div
        style={{
          position: 'absolute',
          top: 70,
          left: offsetX,
          height: 50,
          display: 'flex',
          gap: 380,
          pointerEvents: 'none',
          color: '#fff',
          fontSize: 24,
          zIndex: 9,
        }}
      >
        {ranks.map((rank) => (
          <div className="rank-name-container" key={rank}>
            <div className={selectedRank === rank ? 'choose-rank-name' : ''}>
              {arabNumberToRoman(rank)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}